<template>
  <div class="rounded-md bg-white p-6 shadow-md">
    <template>
      <transition
        enter-active-class="transition-opacity duration-300"
        leave-active-class="transition-opacity duration-300"
        enter-class="opacity-0"
        leave-to-class="opacity-0"
        mode="out-in"
      >
        <div v-if="!isLoading" ref="results">
          <h2 class="my-6 text-center text-xl font-semibold text-gray-700">
            Comprobantes habilitados para pago en portal de pagos
          </h2>

          <div class="flex flex-row-reverse items-center space-y-4">
            <button
              @click="refreshComprobantes"
              class="focus:shadow-outline inline-flex justify-center space-x-2 rounded-md border border-gray-300 bg-white px-4 py-2 text-base font-medium text-gray-700 shadow-sm transition duration-150 ease-in-out hover:bg-cool-gray-200 focus:border-blue-300 focus:outline-none sm:text-sm"
            >
              <span class="text-center text-sm font-bold">Actualizar</span>
              <OutlineRefreshIcon class="h-5 w-5" />
            </button>
          </div>
        </div>
      </transition>

      <transition
        enter-active-class="transition-opacity duration-300"
        leave-active-class="transition-opacity duration-300"
        enter-class="opacity-0"
        leave-to-class="opacity-0"
        mode="out-in"
      >
        <div key="1" v-if="isLoading" class="mt-0 px-2 py-2">
          <Cargando :mensaje="'Buscando comprobantes...'" />
        </div>

        <SinMovimientos
          key="2"
          v-else-if="error"
          :msg="'Ocurrió un error al recuperar la información'"
          :icon="'OutlineExclamationCircleIcon'"
        />

        <SinMovimientos
          key="3"
          v-else-if="comprobantes.length === 0"
          :msg="'No se encontraron datos'"
        />

        <div key="4" v-else class="mb-4 mt-6 space-y-3">
          <ListaComprobantes
            :comprobantes="comprobantesPagination.data"
            v-on:refresh-comprobantes="refreshComprobantes()"
          />

          <nav v-if="comprobantes" class="flex items-center justify-between bg-white px-2 py-3">
            <div class="hidden sm:block">
              <p class="text-sm text-gray-700">
                Mostrando
                <span class="font-medium">{{ comprobantesPagination.offsetStart }}</span>
                a
                <span class="font-medium">{{ comprobantesPagination.offsetEnd }}</span>
                de
                <span class="font-medium">{{ comprobantesPagination.total }}</span>
                comprobantes
              </p>
            </div>

            <div class="flex flex-1 justify-between space-x-4 sm:justify-end">
              <button
                @click="currentPage = currentPage - 1"
                type="button"
                class="inline-flex items-center rounded-md border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700 transition duration-150 ease-in-out focus:outline-none focus:ring focus:ring-gray-300 focus:ring-opacity-50"
                :class="
                  comprobantesPagination.previousPage
                    ? 'bg-white hover:bg-gray-50'
                    : 'cursor-not-allowed bg-gray-100 opacity-50'
                "
                :disabled="!comprobantesPagination.previousPage"
              >
                <SolidChevronLeftIcon class="h-5 w-5" />
                <span>Anterior</span>
              </button>

              <button
                @click="currentPage = currentPage + 1"
                type="button"
                class="inline-flex items-center rounded-md border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700 transition duration-150 ease-in-out hover:bg-gray-50 focus:outline-none focus:ring focus:ring-gray-300 focus:ring-opacity-50"
                :class="
                  comprobantesPagination.nextPage
                    ? 'bg-white hover:bg-gray-50'
                    : 'cursor-not-allowed bg-gray-100 opacity-50'
                "
                :disabled="!comprobantesPagination.nextPage"
              >
                <span>Siguiente</span>
                <SolidChevronRightIcon class="h-5 w-5" />
              </button>
            </div>
          </nav>
        </div>
      </transition>
    </template>
  </div>
</template>

<script>
import { useService } from '@colescba/app-vue'
import { useAcreditacionRolNotario, useAcreditacionServicio, useSession } from '@colescba/ui'

import Cargando from '@/components/Core/Cargando'
import ListaComprobantes from '../components/ListaComprobantes'
import SinMovimientos from '../components/SinMovimientos'
export default {
  components: { SinMovimientos, Cargando, ListaComprobantes },
  mixins: [
    useService('portalPagos'),
    useSession(),
    useAcreditacionServicio(),
    useAcreditacionRolNotario(),
  ],
  data() {
    return {
      currentPage: 1,
      comprobantes: [],
      comprobantesPagination: {},
      error: false,
      isLoading: false,
      categoriaDeudaId: null,
    }
  },
  async mounted() {
    this.categoriaDeudaId = this.$route.params.categoriaDeudaId
    await this.refreshComprobantes()
  },
  methods: {
    async refreshComprobantes() {
      this.error = null
      this.isLoading = true
      this.currentPage = null

      try {
        this.comprobantes = await this.portalPagos.getComprobantes(this.notario.cuitCuil, {
          tipos: this.categoriaDeudaId,
        })
        /*
        await this.actualizarSaldo({
          cuitCuil: this.notario.cuitCuil,
          cuentaNotarial: this.cuentaNotarial,
        })
        */
        this.currentPage = 1
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error)
        this.error = error
      } finally {
        this.isLoading = false
      }
    },
  },
  watch: {
    currentPage() {
      if (this.currentPage === null) return
      this.comprobantesPagination = this.comprobantes.paginate(this.currentPage, this.perPage)

      if (this.comprobantesPagination.data.length > 0) {
        this.$nextTick(() => this.$refs.results.scrollIntoView({ behavior: 'smooth' }))
      }
    },
  },
}
</script>
